/* ============================================================
   UGM Course Viewer — lesson switching, localStorage progress, buy hook
   ============================================================
   Progress is stored client-side (localStorage) for the MVP — keyed by course
   handle. Cross-device progress would require customer metafields via an app
   proxy (Phase 4). Entitlement itself is enforced server-side in Liquid; this
   script only drives UI for content the server already decided to render.
*/
(function () {
  var root = document.querySelector('.ugm-course[data-course-handle]');
  if (!root) return;

  var handle = root.dataset.courseHandle;
  var owns = root.dataset.owns === 'true';
  var variantId = parseInt(root.dataset.variantId, 10);
  var STORE_KEY = 'ugm-course-progress:' + handle;

  // Free-screen offer is FUNNEL-ONLY: the masterclass funnel links here with
  // ?offer=masterclass. Remember it for the session so enrolling from a funnel
  // visit includes the free screen; direct course-page visitors never get it.
  var screenOffer = false;
  try {
    if (/[?&]offer=masterclass/i.test(location.search)) sessionStorage.setItem('ugm_screen_offer', '1');
    screenOffer = sessionStorage.getItem('ugm_screen_offer') === '1';
  } catch (e) { screenOffer = /[?&]offer=masterclass/i.test(location.search); }
  var LAST_KEY = 'ugm-course-last:' + handle;

  var sideBtns = Array.prototype.slice.call(root.querySelectorAll('[data-lesson-go]'));
  var panes = Array.prototype.slice.call(root.querySelectorAll('[data-lesson-pane]'));
  var lessonItems = Array.prototype.slice.call(root.querySelectorAll('.ugm-course__lesson[data-lesson-id]'));
  var progressEl = root.querySelector('#ugm-course-progress');

  /* ---- progress state ---- */
  function loadDone() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveDone(arr) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  var done = loadDone();

  function markItemDone(id, isDone) {
    var li = root.querySelector('.ugm-course__lesson[data-lesson-id="' + cssEscape(id) + '"]');
    if (li) li.classList.toggle('is-done', !!isDone);
  }
  function refreshProgress() {
    lessonItems.forEach(function (li) {
      markItemDone(li.dataset.lessonId, done.indexOf(li.dataset.lessonId) !== -1);
    });
    if (progressEl && owns) {
      var total = sideBtns.length || lessonItems.length;
      var pct = total ? Math.round((countAccessibleDone() / total) * 100) : 0;
      progressEl.textContent = pct + '%';
    }
  }
  function countAccessibleDone() {
    var accessibleIds = sideBtns.map(function (b) { return b.dataset.lessonGo; });
    return done.filter(function (id) { return accessibleIds.indexOf(id) !== -1; }).length;
  }

  /* ---- lesson switching ---- */
  function goLesson(id, scroll) {
    var found = false;
    panes.forEach(function (p) {
      var match = p.dataset.lessonPane === id;
      p.hidden = !match;
      p.classList.toggle('is-active', match);
      if (match) found = true;
    });
    if (!found) return;
    sideBtns.forEach(function (b) {
      b.classList.toggle('is-current', b.dataset.lessonGo === id);
    });
    try { localStorage.setItem(LAST_KEY, id); } catch (e) {}
    if (history.replaceState) history.replaceState(null, '', '#lesson-' + id);
    // Pause any video in a now-hidden pane
    panes.forEach(function (p) {
      if (p.hidden) {
        var vid = p.querySelector('video');
        if (vid && !vid.paused) vid.pause();
      }
    });
    if (scroll) {
      var main = root.querySelector('.ugm-course__main');
      if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function nextAccessibleAfter(id) {
    var idx = sideBtns.findIndex(function (b) { return b.dataset.lessonGo === id; });
    if (idx !== -1 && idx + 1 < sideBtns.length) return sideBtns[idx + 1].dataset.lessonGo;
    return null;
  }

  /* ---- wire up clicks ---- */
  sideBtns.forEach(function (b) {
    b.addEventListener('click', function () { goLesson(b.dataset.lessonGo, true); });
  });

  root.querySelectorAll('[data-lesson-complete]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.lessonComplete;
      if (done.indexOf(id) === -1) { done.push(id); saveDone(done); }
      refreshProgress();
      var next = nextAccessibleAfter(id);
      if (next) goLesson(next, true);
    });
  });

  /* ---- click-to-play poster (custom thumbnail; video loads only on click) ---- */
  root.querySelectorAll('[data-course-poster]').forEach(function (poster) {
    poster.addEventListener('click', function () {
      var player = poster.closest('.ugm-course__player');
      var vid = player && player.querySelector('video');
      poster.style.display = 'none';
      if (vid) { try { vid.play(); } catch (e) {} }
    });
  });

  /* ---- buy hook (non-owners) ---- */
  var buyBtn = root.querySelector('[data-course-buy]');
  if (buyBtn && variantId) {
    buyBtn.addEventListener('click', function () {
      if (window.UGM && window.UGM.cart) {
        if (buyBtn.dataset.busy === '1') return;
        buyBtn.dataset.busy = '1';
        var prevLabel = buyBtn.textContent;
        buyBtn.textContent = 'Adding…';
        // Enrolling adds the free digital bonuses (Session Zero + Twisted Hand), zeroed
        // by the automatic discount. The free Ultimate Game Master Screen (default
        // Portrait/Brown, finish swappable in cart) is added ONLY for funnel visitors.
        var DIGITAL_BONUS = [
          { id: 48624705831145, quantity: 1, properties: { '__digitalbonus': 'true', 'Bonus': 'Free with your enrollment' } },
          { id: 51453798678761, quantity: 1, properties: { '__digitalbonus': 'true', 'Bonus': 'Free with your enrollment' } }
        ];
        if (screenOffer) {
          DIGITAL_BONUS.push({ id: 48255873614057, quantity: 1, properties: { '__screenbonus': 'true', 'Bonus': 'Free with your Masterclass' } });
        }
        var done = function () { if (window.UGM.cart.open) window.UGM.cart.open(); buyBtn.dataset.busy = ''; buyBtn.textContent = prevLabel; };
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var already = (cart.items || []).some(function (i) { return i.id === variantId || i.handle === handle; });
            if (already) return null; // already enrolled in this cart — just show it
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }].concat(DIGITAL_BONUS) })
            }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
          })
          .then(function () { return window.UGM.cart.refresh ? window.UGM.cart.refresh() : null; })
          .then(done)
          .catch(function () { window.location.href = '/cart/add?id=' + variantId + '&quantity=1'; });
      } else {
        // Fallback: standard cart add
        window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
      }
    });
  }

  /* ---- funnel visitors: reflect the free screen in the bonus banner ---- */
  if (screenOffer) {
    var digibanner = root.querySelector('#ugm-digibundle');
    if (digibanner) {
      var dTitle = digibanner.querySelector('.ugm-digibundle__title');
      if (dTitle) dTitle.innerHTML = 'Enroll today and get a <strong>FREE Game Master Screen + two bonus PDFs</strong>';
      var dFoot = digibanner.querySelector('.ugm-digibundle__foot');
      if (dFoot) dFoot.innerHTML = 'Your free <strong>Ultimate Game Master Screen ($139.99 value)</strong> plus both PDFs are added to your order free — choose your screen finish in the cart.';
    }
  }

  /* ---- per-lesson video watch progress (sidebar bars) ----
     Stores the furthest fraction reached per lesson so the bar reflects how
     much of each video the learner has watched. Separate from the
     mark-complete state above; updates live as the video plays. */
  var WATCH_KEY = 'ugm-course-watch:' + handle;
  function loadWatch() {
    try { return JSON.parse(localStorage.getItem(WATCH_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function saveWatch(obj) {
    try { localStorage.setItem(WATCH_KEY, JSON.stringify(obj)); } catch (e) {}
  }
  var watch = loadWatch();
  var watchSaveT;

  function renderWatch(id) {
    var pct = Math.max(0, Math.min(100, Math.round(watch[id] || 0)));
    var li = root.querySelector('.ugm-course__lesson[data-lesson-id="' + cssEscape(id) + '"]');
    if (!li) return;
    var wrap = li.querySelector('[data-lesson-prog]');
    if (!wrap) return;
    var bar = wrap.querySelector('.ugm-course__lesson-prog-bar');
    if (bar) bar.style.width = pct + '%';
    wrap.setAttribute('aria-valuenow', pct);
    li.classList.toggle('is-watched', pct >= 95);
  }

  panes.forEach(function (pane) {
    var id = pane.dataset.lessonPane;
    var vid = pane.querySelector('video');
    if (!vid) return;
    vid.addEventListener('timeupdate', function () {
      var dur = vid.duration;
      if (!dur || !isFinite(dur)) return;
      var pct = (vid.currentTime / dur) * 100;
      if (pct > (watch[id] || 0)) {
        watch[id] = pct;
        renderWatch(id);
        clearTimeout(watchSaveT);
        watchSaveT = setTimeout(function () { saveWatch(watch); }, 600);
      }
    });
    vid.addEventListener('ended', function () {
      watch[id] = 100;
      renderWatch(id);
      saveWatch(watch);
    });
  });

  // paint any stored progress on load
  Object.keys(watch).forEach(renderWatch);

  /* ---- initial lesson: hash → last viewed → first ---- */
  function initialLessonId() {
    var hash = (location.hash || '').replace('#lesson-', '');
    if (hash && sideBtns.some(function (b) { return b.dataset.lessonGo === hash; })) return hash;
    var last;
    try { last = localStorage.getItem(LAST_KEY); } catch (e) {}
    if (last && sideBtns.some(function (b) { return b.dataset.lessonGo === last; })) return last;
    return sideBtns.length ? sideBtns[0].dataset.lessonGo : null;
  }

  /* CSS.escape fallback for older Safari */
  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  refreshProgress();
  var startId = initialLessonId();
  if (startId) goLesson(startId, false);
})();
